// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"6":"6763fea0","678":"component---src-pages-index-js"}[chunkId] + "-" + {"6":"101970d8d8f187edf5d3","678":"db51e947d6036264a8e8"}[chunkId] + ".js";
};